/* Kornerprint — interactions du thème */
(function () {
  'use strict';
  var KP = window.KP || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Utilitaires ---------- */
  function formatMoney(cents, digits) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = Number(cents) / 100;
    var d = digits == null ? 2 : digits;
    var str = value.toLocaleString('fr-FR', { minimumFractionDigits: d, maximumFractionDigits: d });
    var fmt = KP.money || '{{amount}} €';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function () { return str; });
  }
  KP.formatMoney = formatMoney;
  function toast(msg) {
    var t = $('[data-kp-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function parseQty(v) { var m = String(v).replace(/[\s .]/g, '').match(/\d+/); return m ? parseInt(m[0], 10) : 0; }

  /* ---------- Overlays (panier, recherche, menu mobile) ---------- */
  var lastFocus = null;
  function openLayer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = el.querySelector('input[type=search], [tabindex="-1"], button');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeLayer(el) {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (!$('.kp-drawer.is-open, .kp-search.is-open, .kp-mobile-nav.is-open')) document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-kp-close]');
    if (c) { closeLayer(c.closest('.kp-drawer, .kp-search, .kp-mobile-nav')); return; }
    var o = e.target.closest('[data-kp-open]');
    if (o) {
      e.preventDefault();
      var id = o.getAttribute('data-kp-open');
      var el = document.getElementById(id);
      if (id === 'kp-cart') renderCart();
      openLayer(el);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.kp-drawer.is-open, .kp-search.is-open, .kp-mobile-nav.is-open').forEach(closeLayer);
  });

  /* ---------- Header ---------- */
  function initHeader() {
    var h = $('.kp-header');
    if (h) {
      var onS = function () { h.classList.toggle('is-scrolled', window.scrollY > 8); };
      window.addEventListener('scroll', onS, { passive: true }); onS();
    }
    $$('.kp-nav__item[data-has-mega]').forEach(function (item) {
      var btn = item.querySelector('.kp-nav__link');
      var t;
      function open() { clearTimeout(t); $$('.kp-nav__item.is-open').forEach(function (o) { if (o !== item) close(o); }); item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
      function close(it) { it = it || item; it.classList.remove('is-open'); var b = it.querySelector('.kp-nav__link'); if (b) b.setAttribute('aria-expanded', 'false'); }
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', function () { t = setTimeout(close, 140); });
      btn.addEventListener('click', function (e) {
        if (btn.tagName === 'A' && item.classList.contains('is-open')) return;
        e.preventDefault(); item.classList.contains('is-open') ? close() : open();
      });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(); });
      item.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); btn.focus(); } });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.kp-nav')) $$('.kp-nav__item.is-open').forEach(function (i) { i.classList.remove('is-open'); }); });
  }

  /* ---------- Panier (AJAX) ---------- */
  function setCount(n) {
    $$('[data-kp-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = !n; });
    $$('[data-kp-cart-count-text]').forEach(function (b) { b.textContent = n ? '(' + n + ')' : ''; });
  }
  function lineHTML(item, i) {
    var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
    var opts = (item.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; })
      .map(function (o) { return esc(o.name) + ' : ' + esc(o.value); }).join('<br>');
    var props = item.properties ? Object.keys(item.properties).filter(function (k) { return k.charAt(0) !== '_' && item.properties[k]; })
      .map(function (k) { var v = String(item.properties[k]); return esc(k) + ' : ' + (v.indexOf('http') === 0 ? 'fichier joint' : esc(v)); }).join('<br>') : '';
    return '<div class="kp-line" data-line="' + (i + 1) + '">' +
      '<a class="kp-line__img" href="' + item.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div><a class="kp-line__title" href="' + item.url + '">' + esc(item.product_title) + '</a>' +
      '<div class="kp-line__opts">' + opts + (props ? '<br>' + props : '') + '</div>' +
      '<div class="kp-qty"><button type="button" data-q="-1" aria-label="Diminuer">−</button><input type="number" min="0" value="' + item.quantity + '" aria-label="Quantité"><button type="button" data-q="1" aria-label="Augmenter">+</button></div>' +
      '<button type="button" class="kp-remove" data-remove>Retirer</button></div>' +
      '<div class="kp-line__price">' + formatMoney(item.final_line_price) + '</div></div>';
  }
  function renderCart(cart) {
    var body = $('[data-kp-cart-body]'), foot = $('[data-kp-cart-foot]');
    if (!body) return Promise.resolve();
    var p = cart ? Promise.resolve(cart) : fetch(KP.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    return p.then(function (c) {
      setCount(c.item_count);
      if (!c.item_count) {
        body.innerHTML = '<div class="kp-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg><p><strong>Votre panier est vide</strong></p><p class="kp-muted kp-small">Découvrez nos emballages personnalisables.</p><a class="kp-btn kp-btn--lime" href="/collections/all">Voir les produits</a></div>';
        if (foot) foot.hidden = true;
        return;
      }
      body.innerHTML = c.items.map(lineHTML).join('');
      if (foot) { foot.hidden = false; $('[data-kp-cart-total]', foot).textContent = formatMoney(c.total_price); }
    }).catch(function () { body.innerHTML = '<p class="kp-muted">Impossible de charger le panier.</p>'; });
  }
  function changeLine(line, qty, scope) {
    scope && scope.classList.add('is-busy');
    return fetch(KP.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (document.body.classList.contains('template-cart')) { location.reload(); return; } renderCart(c); });
  }
  function initCartDrawer() {
    var body = $('[data-kp-cart-body]');
    if (!body) return;
    body.addEventListener('click', function (e) {
      var line = e.target.closest('.kp-line'); if (!line) return;
      var n = +line.dataset.line, input = $('input', line);
      if (e.target.closest('[data-q]')) changeLine(n, Math.max(0, (+input.value || 0) + (+e.target.closest('[data-q]').dataset.q)), line);
      if (e.target.closest('[data-remove]')) changeLine(n, 0, line);
    });
    body.addEventListener('change', function (e) {
      var line = e.target.closest('.kp-line'); if (line && e.target.matches('input')) changeLine(+line.dataset.line, Math.max(0, +e.target.value || 0), line);
    });
  }
  /* Page panier : boutons +/- */
  function initCartPage() {
    $$('[data-kp-cart-page] .kp-line').forEach(function (line) {
      var n = +line.dataset.line, input = $('input', line);
      line.addEventListener('click', function (e) {
        if (e.target.closest('[data-q]')) changeLine(n, Math.max(0, (+input.value || 0) + (+e.target.closest('[data-q]').dataset.q)), line);
        if (e.target.closest('[data-remove]')) { e.preventDefault(); changeLine(n, 0, line); }
      });
      if (input) input.addEventListener('change', function () { changeLine(n, Math.max(0, +input.value || 0), line); });
    });
  }
  KP.addToCart = function (form, btn) {
    btn && btn.classList.add('is-loading');
    var fd = new FormData(form), clean = new FormData();
    fd.forEach(function (v, k) { if ((typeof v === 'string' && v.trim() === '') || (v instanceof File && !v.size)) return; clean.append(k, v); });
    fd = clean;
    return fetch(KP.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return renderCart(); })
      .then(function () { openLayer($('#kp-cart')); toast('Ajouté au panier ✓'); })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Erreur, veuillez réessayer'); })
      .finally(function () { btn && btn.classList.remove('is-loading'); });
  };
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-kp-ajax-add]')) return;
    var file = form.querySelector('input[type=file]');
    if (file && file.files && file.files.length) return; /* envoi classique pour joindre le fichier */
    e.preventDefault();
    KP.addToCart(form, form.querySelector('[type=submit]'));
  });

  /* ---------- Recherche instantanée ---------- */
  function initSearch() {
    var input = $('[data-kp-search-input]'), box = $('[data-kp-search-results]');
    if (!input || !box) return;
    var initial = box.innerHTML, t, ctrl;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(t);
      if (q.length < 2) { box.innerHTML = initial; return; }
      t = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = 'AbortController' in window ? new AbortController() : null;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var res = d.resources && d.resources.results || {};
            var cols = res.collections || [], prods = res.products || [];
            if (!cols.length && !prods.length) { box.innerHTML = '<p class="kp-muted">Aucun résultat pour « ' + esc(q) + ' ». <a class="kp-link" href="/pages/demande-de-devis">Demandez-nous un devis sur mesure</a></p>'; return; }
            var html = '';
            if (cols.length) html += '<p class="kp-small kp-muted">Catégories</p><div class="kp-chips" style="margin-bottom:14px">' + cols.map(function (c) { return '<a class="kp-chip" href="' + c.url + '">' + esc(c.title) + '</a>'; }).join('') + '</div>';
            if (prods.length) html += '<p class="kp-small kp-muted">Produits</p>' + prods.map(function (p) {
              return '<a class="kp-search__item" href="' + p.url + '">' + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') + '<span><strong>' + esc(p.title) + '</strong><small>À partir de ' + formatMoney(Math.round(parseFloat(p.price_min || p.price) * 100)) + '</small></span></a>';
            }).join('');
            html += '<p style="margin:12px 8px 0"><a class="kp-link-arrow" href="/search?q=' + encodeURIComponent(q) + '">Voir tous les résultats →</a></p>';
            box.innerHTML = html;
          }).catch(function () {});
      }, 180);
    });
  }

  /* ---------- Apparition au défilement ---------- */
  function initReveal(scope) {
    var els = $$('.kp-reveal:not(.is-in)', scope);
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Onglets génériques ---------- */
  function initTabs(scope) {
    $$('[data-kp-tabs]', scope).forEach(function (root) {
      if (root._kp) return; root._kp = 1;
      var tabs = $$('[role=tab]', root);
      function sel(t, focus) {
        tabs.forEach(function (x) {
          var on = x === t; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1;
          var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.classList.toggle('is-active', on);
        });
        if (focus) t.focus();
        var bar = t.parentElement; if (bar && bar.scrollWidth > bar.clientWidth) bar.scrollTo({ left: t.offsetLeft - (bar.clientWidth - t.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { sel(t); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (n) { e.preventDefault(); sel(n, true); }
        });
      });
    });
  }

  /* ---------- Carrousels ---------- */
  function initRails(scope) {
    $$('[data-kp-rail]', scope).forEach(function (root) {
      if (root._kp) return; root._kp = 1;
      var track = $('.kp-rail__track', root), prev = $('[data-dir=prev]', root), next = $('[data-dir=next]', root);
      if (!track) return;
      function upd() { var m = track.scrollWidth - track.clientWidth; if (prev) prev.disabled = track.scrollLeft < 4; if (next) next.disabled = track.scrollLeft > m - 4; }
      function go(d) { var it = track.firstElementChild; var w = it ? it.getBoundingClientRect().width + 24 : 300; track.scrollBy({ left: d * w * Math.max(1, Math.floor(track.clientWidth / w)), behavior: reduce ? 'auto' : 'smooth' }); }
      prev && prev.addEventListener('click', function () { go(-1); });
      next && next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    });
  }

  /* ---------- Lire la suite ---------- */
  function initReadmore(scope) {
    $$('[data-kp-readmore]', scope).forEach(function (btn) {
      var box = document.getElementById(btn.getAttribute('aria-controls'));
      if (!box) return;
      if (box.scrollHeight <= box.clientHeight + 10) { box.classList.add('is-open'); btn.hidden = true; return; }
      btn.addEventListener('click', function () { var o = box.classList.toggle('is-open'); btn.setAttribute('aria-expanded', o); btn.textContent = o ? 'Réduire' : 'Lire la suite'; });
    });
  }

  /* ---------- Assistant de choix ---------- */
  function initFinder(scope) {
    $$('[data-kp-finder]', scope).forEach(function (root) {
      if (root._kp) return; root._kp = 1;
      var steps = $$('.kp-finder__step', root), bars = $$('.kp-finder__progress span', root), choice = null;
      function show(i) { steps.forEach(function (s, j) { s.classList.toggle('is-active', i === j); }); bars.forEach(function (b, j) { b.classList.toggle('is-done', j < i); }); }
      $$('[data-need]', root).forEach(function (b) { b.addEventListener('click', function () { choice = b; $$('[data-need-label]', root).forEach(function (l) { l.textContent = b.dataset.label; }); show(1); }); });
      $$('[data-qty]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          if (!choice) return;
          var small = b.dataset.qty === 'small', d = choice.dataset;
          $('[data-r-title]', root).textContent = d.label + (small ? ' · petite série' : ' · grande série');
          $('[data-r-text]', root).textContent = small ? d.textSmall : d.textLarge;
          $('[data-r-link]', root).href = (small ? d.urlSmall : d.urlLarge) || d.urlLarge || d.urlSmall || '/collections/all';
          var img = $('[data-r-img]', root); if (img) { img.src = d.img || ''; img.hidden = !d.img; }
          show(2);
        });
      });
      $$('[data-restart]', root).forEach(function (b) { b.addEventListener('click', function () { show(0); }); });
    });
  }

  /* ---------- Galerie produit ---------- */
  function initGallery(root) {
    var main = $('.kp-gallery__main', root); if (!main) return null;
    var img = $('img', main), thumbs = $$('.kp-gallery__thumb', root), count = $('.kp-gallery__count', root), idx = 0;
    function go(i) {
      if (!thumbs.length) return;
      idx = (i + thumbs.length) % thumbs.length;
      var t = thumbs[idx];
      img.src = t.dataset.src; img.srcset = t.dataset.srcset || ''; img.alt = t.dataset.alt || '';
      thumbs.forEach(function (x, j) { x.setAttribute('aria-current', j === idx); });
      if (count) count.textContent = (idx + 1) + ' / ' + thumbs.length;
      t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var p = $('.kp-gallery__nav--prev', root), n = $('.kp-gallery__nav--next', root);
    p && p.addEventListener('click', function (e) { e.stopPropagation(); go(idx - 1); });
    n && n.addEventListener('click', function (e) { e.stopPropagation(); go(idx + 1); });
    if (window.matchMedia('(hover:hover)').matches) {
      main.addEventListener('mousemove', function (e) { var r = main.getBoundingClientRect(); main.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%'); main.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%'); });
      main.addEventListener('click', function (e) { if (!e.target.closest('.kp-gallery__nav')) main.classList.toggle('is-zoom'); });
      main.addEventListener('mouseleave', function () { main.classList.remove('is-zoom'); });
    }
    var sx = null;
    main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) { if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1)); sx = null; });
    return { toMedia: function (id) { var i = thumbs.findIndex(function (t) { return t.dataset.mediaId == id; }); if (i > -1) go(i); } };
  }

  /* ---------- Configurateur produit ---------- */
  function initProduct(scope) {
    $$('[data-kp-product]', scope).forEach(function (root) {
      if (root._kp) return; root._kp = 1;
      var dataEl = $('script[data-kp-product-json]', root); if (!dataEl) return;
      var product = JSON.parse(dataEl.textContent);
      var variants = product.variants || [];
      var qIdx = +root.dataset.qtyIndex; if (isNaN(qIdx)) qIdx = -1;
      var gallery = initGallery(root);
      var form = $('form[data-kp-ajax-add]', root);
      var idInput = form ? $('input[name=id]', form) : null;
      var groups = $$('.kp-opt-group[data-index]', root);
      var selected = [];
      var current = variants.find(function (v) { return String(v.id) === String(root.dataset.variant); }) || variants.find(function (v) { return v.available; }) || variants[0];
      if (current) selected = current.options.slice();

      var els = {
        unitRow: $('[data-kp-unit-row]', root), unit: $('[data-kp-unit]', root), unitOld: $('[data-kp-unit-old]', root), save: $('[data-kp-save]', root),
        total: $('[data-kp-total]', root), totalLabel: $('[data-kp-total-label]', root), compare: $('[data-kp-compare]', root),
        atc: $('[data-kp-atc]', root), tiers: $('[data-kp-tiers-body]', root), range: $('[data-kp-range]', root),
        stickyPrice: $('[data-kp-sticky-price]'), stickyInfo: $('[data-kp-sticky-info]'), sku: $('[data-kp-sku]', root)
      };

      function find(opts) { return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }); }
      function closest(i, val) {
        var best = null, score = -1;
        variants.forEach(function (v) {
          if (v.options[i] !== val) return;
          var s = v.options.reduce(function (a, o, j) { return a + (o === selected[j] ? 1 : 0); }, 0) + (v.available ? .5 : 0);
          if (s > score) { score = s; best = v; }
        });
        return best;
      }
      function isLot(v) { return qIdx > -1 && parseQty(v.options[qIdx]) > 1 && v.price >= 500; }
      function unitOf(v) { var q = parseQty(v.options[qIdx]); return q ? v.price / q : v.price; }
      function siblings(v) { /* variantes identiques sauf la quantité */
        return variants.filter(function (x) { return x.options.every(function (o, j) { return j === qIdx || o === v.options[j]; }); })
          .sort(function (a, b) { return parseQty(a.options[qIdx]) - parseQty(b.options[qIdx]); });
      }
      function unitStr(c) { return formatMoney(c, c < 100 ? 3 : 2); }

      function refresh() {
        var v = find(selected);
        current = v || null;
        /* pastilles */
        groups.forEach(function (g) {
          var i = +g.dataset.index;
          $$('.kp-pill', g).forEach(function (p) {
            var val = p.dataset.value, on = val === selected[i];
            p.setAttribute('aria-checked', on); p.tabIndex = on ? 0 : -1;
            var test = selected.slice(); test[i] = val;
            var tv = find(test);
            p.classList.toggle('is-unavailable', !tv || !tv.available);
          });
          var lbl = $('.kp-opt-group__value', g); if (lbl) lbl.textContent = selected[i] || '';
        });
        if (els.range && qIdx > -1) {
          var vals = $$('.kp-pill', groups.find(function (g) { return +g.dataset.index === qIdx; }) || root).map(function (p) { return p.dataset.value; });
          var k = vals.indexOf(selected[qIdx]); if (k > -1) { els.range.value = k; els.range.style.setProperty('--p', (vals.length > 1 ? k / (vals.length - 1) * 100 : 0) + '%'); }
        }
        if (!v) {
          if (els.atc) { els.atc.disabled = true; els.atc.textContent = 'Combinaison indisponible'; }
          if (els.total) els.total.textContent = '—';
          return;
        }
        if (idInput) idInput.value = v.id;
        if (els.sku) els.sku.textContent = v.sku ? 'Réf. ' + v.sku : '';
        if (els.atc) { els.atc.disabled = !v.available; els.atc.innerHTML = v.available ? els.atc.dataset.label : 'Épuisé'; }
        if (els.total) els.total.textContent = formatMoney(v.price);
        if (els.compare) { var c = v.compare_at_price > v.price; els.compare.hidden = !c; if (c) els.compare.textContent = formatMoney(v.compare_at_price); }
        var lot = isLot(v), sib = lot ? siblings(v) : [];
        if (els.unitRow) els.unitRow.hidden = !lot;
        if (els.totalLabel) els.totalLabel.textContent = lot ? 'Total HT (' + parseQty(v.options[qIdx]).toLocaleString('fr-FR') + ' unités)' : 'Prix HT';
        if (lot) {
          var u = unitOf(v), base = sib.length ? unitOf(sib[0]) : u, pct = base > u ? Math.round((1 - u / base) * 100) : 0;
          els.unit.textContent = unitStr(u);
          if (els.unitOld) { els.unitOld.hidden = !pct; els.unitOld.textContent = unitStr(base); }
          if (els.save) { els.save.hidden = !pct; els.save.textContent = '-' + pct + '%'; }
          /* badges d'économie sur les quantités */
          var qg = groups.find(function (g) { return +g.dataset.index === qIdx; });
          if (qg) $$('.kp-pill', qg).forEach(function (p) {
            var s = sib.find(function (x) { return x.options[qIdx] === p.dataset.value; });
            var b = $('.kp-pill__save', p); var pc = s && base ? Math.round((1 - unitOf(s) / base) * 100) : 0;
            if (pc > 0) { if (!b) { b = document.createElement('span'); b.className = 'kp-pill__save'; p.appendChild(b); } b.textContent = '-' + pc + '%'; } else if (b) b.remove();
            var sm = $('small', p); if (sm && s) sm.textContent = unitStr(unitOf(s)) + ' / u.';
          });
          if (els.tiers) els.tiers.innerHTML = sib.map(function (s) {
            var pc = base ? Math.round((1 - unitOf(s) / base) * 100) : 0;
            return '<tr data-q="' + esc(s.options[qIdx]) + '"' + (s.id === v.id ? ' class="is-current"' : '') + '><td>' + parseQty(s.options[qIdx]).toLocaleString('fr-FR') + '</td><td>' + unitStr(unitOf(s)) + (pc > 0 ? ' <span class="kp-price-save">-' + pc + '%</span>' : '') + '</td><td>' + formatMoney(s.price) + '</td></tr>';
          }).join('');
        }
        var tiersBox = $('.kp-tiers', root); if (tiersBox) tiersBox.hidden = !lot || sib.length < 2;
        if (els.stickyPrice) els.stickyPrice.textContent = formatMoney(v.price);
        if (els.stickyInfo) els.stickyInfo.textContent = v.title;
        if (gallery && v.featured_media) gallery.toMedia(v.featured_media.id);
        if (window.history.replaceState && root.dataset.updateUrl !== 'false') {
          var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
        }
      }

      groups.forEach(function (g) {
        var i = +g.dataset.index;
        g.addEventListener('click', function (e) {
          var p = e.target.closest('.kp-pill'); if (!p) return;
          selected[i] = p.dataset.value;
          if (!find(selected)) { var c = closest(i, p.dataset.value); if (c) selected = c.options.slice(); }
          refresh();
        });
        g.addEventListener('keydown', function (e) {
          if (['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].indexOf(e.key) < 0) return;
          var pills = $$('.kp-pill', g), k = pills.findIndex(function (p) { return p.dataset.value === selected[i]; });
          var n = pills[(k + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + pills.length) % pills.length];
          e.preventDefault(); n.click(); n.focus();
        });
      });
      if (els.range) els.range.addEventListener('input', function () {
        var qg = groups.find(function (g) { return +g.dataset.index === qIdx; });
        var p = qg && $$('.kp-pill', qg)[+els.range.value]; if (p) p.click();
      });
      if (els.tiers) els.tiers.addEventListener('click', function (e) {
        var tr = e.target.closest('tr[data-q]'); if (!tr) return;
        var qg = groups.find(function (g) { return +g.dataset.index === qIdx; });
        var p = qg && $$('.kp-pill', qg).find(function (x) { return x.dataset.value === tr.dataset.q; }); if (p) p.click();
      });

      /* Dépôt de logo */
      var up = $('.kp-upload', root);
      if (up) {
        var fi = $('input[type=file]', up), label = $('[data-kp-upload-label]', up);
        fi.addEventListener('change', function () {
          var f = fi.files[0];
          if (f && f.size > 20 * 1024 * 1024) { toast('Fichier trop lourd (20 Mo max)'); fi.value = ''; return; }
          label.textContent = f ? '✓ ' + f.name : 'Ajouter votre logo';
          if (form && f) form.setAttribute('enctype', 'multipart/form-data');
        });
        ['dragenter', 'dragover'].forEach(function (ev) { up.addEventListener(ev, function (e) { e.preventDefault(); up.classList.add('is-drag'); }); });
        ['dragleave', 'drop'].forEach(function (ev) { up.addEventListener(ev, function (e) { e.preventDefault(); up.classList.remove('is-drag'); }); });
        up.addEventListener('drop', function (e) { if (e.dataTransfer.files.length) { fi.files = e.dataTransfer.files; fi.dispatchEvent(new Event('change')); } });
      }

      /* Barre d'achat collante (mobile) */
      var sticky = $('.kp-sticky-atc');
      if (sticky && els.atc && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(els.atc);
        var sb = $('button', sticky); if (sb) sb.addEventListener('click', function () { els.atc.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); });
      }
      refresh();
    });
  }

  function init(scope) {
    scope = scope || document;
    initReveal(scope); initTabs(scope); initRails(scope); initReadmore(scope); initFinder(scope); initProduct(scope);
  }
  document.addEventListener('DOMContentLoaded', function () {
    initHeader(); initCartDrawer(); initCartPage(); initSearch(); init();
  });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
